import { styled } from "@mui/material/styles";

interface TooltipStyleOptions {
  color?: string;
  backgroundColor?: string;
}

const DEFAULT_TOOLTIP_COLOR = "var(--color-text-primary)";
const DEFAULT_TOOLTIP_BACKGROUND_COLOR = "var(--color-background-surface)";

export function getToolTipStyle({
  color = DEFAULT_TOOLTIP_COLOR,
  backgroundColor = DEFAULT_TOOLTIP_BACKGROUND_COLOR,
}: TooltipStyleOptions) {
  return {
    tooltip: {
      sx: {
        margin: "var(--space-2xl)",
        padding: "var(--space-2xl)",
        borderRadius: "var(--radius-md)",
        boxShadow: "var(--shadow-md)",
        color,
        backgroundColor,
      },
    },
    arrow: {
      sx: {
        color: backgroundColor,
      },
    },
  };
}

export const TooltipWrapper = styled("span")({
  display: "inline-flex",
  cursor: "pointer",
});
